import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Button } from "@mui/material";
import { RootState } from "types";

import DB from "_DatabaseFunctions/directConnect";
import ModalComp from "app/Components/Modals/ModalTemplate";

import { toast } from "react-toastify";

interface ProfileModalProps {
  dets: {
    open: boolean;
    status: string;
  };
  reqInfo: {
    playerName: string;
    playerId: string;
    listType: string;
  };
}

function ProfileModal({ dets, reqInfo }: ProfileModalProps) {
  const { playerName, playerId, listType } = reqInfo;
  const user = useSelector((state: RootState) => state.user.user);
  const whitelist = useSelector((state: RootState) => state.host.whitelist);
  const blacklist = useSelector((state: RootState) => state.host.blacklist);
  const [modalData, setModalData] = useState({ type: "info" });
  const [open, setShow] = useState<boolean>(false);

  useEffect(() => {
    setShow(dets.open);
    if (dets.status == "error") {
      // if player is already on the other list
      setModalData({
        title: "Error",
        type: "error",
        msg: `${playerName} cannot be on both your Blacklist and Whitelist`,
      });
    } else {
      // set details based on the add/remove the player from clicked list
      setModalDets();
    }
  }, [dets, reqInfo]);

  const setModalDets = () => {
    if (listType === "Blacklist") {
      if (blacklist[playerId]) {
        setModalData({
          title: `Un${listType[0].toLowerCase()}${listType.slice(
            1,
          )} ${playerName}`,
          msg: `Remove ${playerName} from ${listType}?`,
          type: "info",
        });
      } else {
        setModalData({
          title: `${listType} ${playerName}`,
          msg: `Add ${playerName} to ${listType}?`,
          type: "info",
        });
      }
    } else if (listType === "Whitelist") {
      if (whitelist[playerId]) {
        setModalData({
          title: `Un${listType[0].toLowerCase()}${listType.slice(
            1,
          )} ${playerName}`,
          msg: `Remove ${playerName} from ${listType}?`,
          type: "info",
        });
      } else {
        setModalData({
          title: `${listType} ${playerName}`,
          msg: `Add ${playerName} to ${listType}?`,
          type: "info",
        });
      }
    }
  };

  const submit = async () => {
    let action = "";
    if (listType === "Blacklist") {
      if (blacklist[playerId]) {
        DB.removeFromBlacklist(user.uid, playerId);
        action = "removed";
      } else {
        DB.addPlayerToBlacklist(user.uid, playerId, playerName);
        action = "added";
      }
    } else if (listType === "Whitelist") {
      if (whitelist[playerId]) {
        action = "removed";
        DB.removeFromWhitelist(user.uid, playerId);
      } else {
        DB.addPlayerToWhitelist(user.uid, playerId, playerName);
        action = "added";
      }
    }
    toast(`${playerName} ${action} to ${listType} successfully`, {
      type: toast.TYPE.SUCCESS,
      position: "bottom-center",
    });
    setShow(false);
  };

  const modalChildren = () => (
    <div>
      <Button variant="success" onClick={submit}>
        Confirm
      </Button>{" "}
      <Button variant="danger" onClick={() => setShow(false)}>
        Cancel
      </Button>
    </div>
  );

  return (
    <ModalComp
      title={modalData.title}
      modalType={modalData.type}
      msg={modalData.msg}
      show={open}
      onClose={() => setShow(false)}
    >
      {modalChildren()}
    </ModalComp>
  );
}

export default ProfileModal;
